import { Injectable, Type } from '@angular/core';
import { BaseFlowsService } from '@kinet-open-network/client/flows/data-access';
import {
  FlowChangePrices,
  FlowChangePricesStepData,
} from './flow-change-prices.model';

@Injectable({ providedIn: 'root' })
export class FlowChangePricesService extends BaseFlowsService<
  FlowChangePrices,
  'id',
  FlowChangePricesStepData
> {
  override readonly flowType = 'change-prices';
  override model: Type<FlowChangePrices> = FlowChangePrices;
  override stepDataClass: Type<FlowChangePricesStepData> =
    FlowChangePricesStepData;
}
